// Auto-generated file
export default {};
